const AVATAR_FALLBACK_COLORS = [
  "bg-[#3B82F6]",
  "bg-[#10B981]",
  "bg-[#F59E0B]",
  "bg-[#8B5CF6]",
  "bg-[#EC4899]",
  "bg-[#06B6D4]",
  "bg-[#EF4444]",
  "bg-[#6366F1]",
] as const;

export function getAvatarFallbackColor(name: string) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_FALLBACK_COLORS[Math.abs(hash) % AVATAR_FALLBACK_COLORS.length];
}

export function getDistinctAvatarFallbackColors(names: string[]) {
  const usedColors = new Set<string>();

  return names.map((name) => {
    const initialColor = getAvatarFallbackColor(name);
    const initialIndex = AVATAR_FALLBACK_COLORS.indexOf(initialColor);

    for (let offset = 0; offset < AVATAR_FALLBACK_COLORS.length; offset++) {
      const color = AVATAR_FALLBACK_COLORS[(initialIndex + offset) % AVATAR_FALLBACK_COLORS.length];
      if (!usedColors.has(color)) {
        usedColors.add(color);
        return color;
      }
    }

    return initialColor;
  });
}
